import Date from './Date'

export default Date



// WEBPACK FOOTER //
// ./src/components/Date/index.js